export default "__VITE_ASSET__BrGnSUYT__"